import { render, staticRenderFns } from "./TheCollections.vue?vue&type=template&id=71737663&scoped=true&"
import script from "./TheCollections.vue?vue&type=script&lang=js&"
export * from "./TheCollections.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./TheCollections.vue?vue&type=style&index=0&id=71737663&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "71737663",
  "bbfaeef2"
  
)

component.options.__file = "TheCollections.vue"
export default component.exports